export default class PubSub {
    /** @param {{maxListeners?:number}} opts */
    constructor({ maxListeners = 50 } = {}) {
        this._topics = new Map();
        this._max = maxListeners;
    }

    /** Subscribe to a topic. Returns an unsubscribe function. */
    on(topic, handler) {
        if (!this._topics.has(topic)) this._topics.set(topic, new Set());
        const set = this._topics.get(topic);
        set.add(handler);
        if (set.size > this._max && process?.env?.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn(`[PubSub] Too many listeners for "${topic}" (${set.size})`);
        }
        return () => this.off(topic, handler);
    }

    /** Subscribe once. Handler is auto-removed after the first emit. */
    once(topic, handler) {
        const off = this.on(topic, (...args) => { off(); handler(...args); });
        return off;
    }

    /** Unsubscribe. If handler omitted, clears the topic entirely. */
    off(topic, handler) {
        const set = this._topics.get(topic);
        if (!set) return;
        if (handler) set.delete(handler); else set.clear();
        if (set.size === 0) this._topics.delete(topic);
    }

    /** Publish an event; returns number of listeners invoked. */
    emit(topic, ...args) {
        const set = this._topics.get(topic);
        if (!set || set.size === 0) return 0;
        // Clone to avoid mutation during iteration
        Array.from(set).forEach((fn) => { try { fn(...args); } catch (e) { /* swallow */ } });
        return set.size;
    }

    /** Clear all topics or a single topic. */
    clear(topic) {
        if (typeof topic === 'string') this._topics.delete(topic); else this._topics.clear();
    }
}

// Shared instance for convenience
export const bus = new PubSub();
